import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { ProfileState } from '@work-frontend-monorepo/work-ui/state-management';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorkIsLoggedInService {
  private store = inject(Store);
  private router = inject(Router);


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.store.selectSnapshot(ProfileState.profile)) {
      this.router.navigate(['/'], { queryParams: { returnUrl: state.url } }).then();
      return false;
    } else {
      return true;
    }
  }
}

export const IsLoggedInGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return <boolean>inject(WorkIsLoggedInService).canActivate(next, state);
};
